import { paths } from '@luxuryescapes/contract-svc-merchandise'
import requestUtils, { authOptions } from 'api/requestUtils'

type Response = paths['/api/merchandise/adverts']['get']['responses']['200']['content']['application/json']

async function requestMerchandiseAdverts(token?: string): Promise<App.AdvertCatalogue> {
  return requestUtils.get<Response>(
    '/api/merchandise/adverts', authOptions(token),
  ).then((response): App.AdvertCatalogue => {
    return {
      advertItems: response.result.adverts.map(advert => {
        return {
          id: advert.id,
          name: advert.name,
          category: advert.category,
          imageId: advert.imageId,
          price: advert.price,
        }
      }),
    }
  })
}

export default requestMerchandiseAdverts
